// components
import Link from '@/components/utilities/SmartLink';
import { Button } from '@/components/ui/button';
import { Icon } from '@/components/ui/icon';
import VisibleLoading from '@/components/utilities/VisibleLoading';
import { useInquiryModal } from '@/components/utilities/InquiryModalContext';

const ALLOWED_TITLE_TAGS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

const TextBlock = ({ title, titleTag, text, buttons, textBlockVariant: variant }) => {
  const Tag = ALLOWED_TITLE_TAGS.includes(titleTag) ? titleTag : 'h2';
  const { open } = useInquiryModal();

  return (
    <div className="max-w-[496px] text-left">
      <VisibleLoading delay={75}>
        {({ ref, className }) => (
          <Tag ref={ref} className={className}>
            {title}
          </Tag>
        )}
      </VisibleLoading>

      {text && (
        <VisibleLoading delay={150}>
          {({ ref, className }) => (
            <div
              ref={ref}
              className={`txt-lg mt-6 whitespace-pre-wrap ${variant === 'light' ? 'text-grey-700' : 'text-white-75'} ${className || ''}`.trim()}
            >
              {text}
            </div>
          )}
        </VisibleLoading>
      )}

      {buttons && buttons.length > 0 && (
        <div className="mt-8 flex flex-wrap gap-4">
          {buttons.map((button, index) => (
            <VisibleLoading key={button.id} delay={(index + 1) * 200}>
              {({ ref, className }) => {
                const mergedClassName = `basis-full xl:basis-auto ${className || ''}`.trim();

                if (button.serviceId) {
                  return (
                    <Button
                      ref={ref}
                      variant={button.variant}
                      size={button.size}
                      type="button"
                      onClick={() => open(button.serviceId)}
                      className={mergedClassName}
                    >
                      <Icon type={button.icon} /> {button.label}
                    </Button>
                  );
                }

                return (
                  <Button
                    ref={ref}
                    variant={button.variant}
                    size={button.size}
                    asChild={true}
                    className={mergedClassName}
                  >
                    <Link href={button.url || ''}>
                      <Icon type={button.icon} /> {button.label}
                    </Link>
                  </Button>
                );
              }}
            </VisibleLoading>
          ))}
        </div>
      )}
    </div>
  );
};
export default TextBlock;
